<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#glucide2">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Glucide, din care</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">6.3</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">g</span></div>

    </div>

    <div id="glucide2" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Zaharuri</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">6.2</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Lactoză</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">5.8</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">g</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "glucide",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style>

</style>
